/* eslint-disable jsx-a11y/label-has-for */

import React from 'react';
import moment from 'moment';
import Modal from '../../../Modal';
import ReferenceCheckContent from './ReferenceCheckContent';
import { LOG_MESSAGES } from '../../../../constants';

class ReferenceCheckModal extends Modal.Manager {
  render() {
    const {
      handleClose,
      handleShow,
      state: { showModal, visible },
      props: { id, data, documents, update, user },
    } = this;

    return (
      <span>
        <a href="/" className="dropdown-menu-link" onClick={handleShow}>
          Edit
        </a>
        {showModal && (
          <ModalComponent
            visible={visible}
            handleClose={handleClose}
            data={data}
            id={id}
            documents={documents}
            update={update}
            user={user}
          />
        )}
      </span>
    );
  }
}

class ModalComponent extends ReferenceCheckContent {
  constructor({ data }) {
    super();

    this.state = data;
  }

  onSubmit = () => {
    const {
      props: { id, handleClose, documents, update, user },
      state,
    } = this;

    const newReference = {
      ...state,
      dateModified: moment().format('MM/DD/YYYY'),
      lastEditedBy: user,
    };

    documents.editReference(newReference, id);
    update(LOG_MESSAGES.EXISTING_REFERENCE_EDITED);
    handleClose();
  };
}

export default ReferenceCheckModal;
